// @ts-nocheck
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, authenticateClient } from '../services/api';
import { toast } from 'react-toastify';
import Loader from '../components/common/Loader';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsLoading(true);

        // Add debug log
        console.log('Submitting login with:', { email, password });

        try {
            const response = await login(email, password);
            console.log('Login response:', response);
            
            if (response.token && response.user) {
                // Clear any existing data first
                localStorage.clear();
                
                // Set new auth data
                localStorage.setItem('auth_token', response.token);
                localStorage.setItem('user_role', response.user.role);
                localStorage.setItem('user_id', response.user.id);
                
                // If user is a client, store client_id
                if (response.user.client_id) {
                    localStorage.setItem('client_id', response.user.client_id);
                }
                
                // Force a page refresh to ensure clean state
                toast.success('Login successful!');
                if (response.user.role === 'consultant') {
                    window.location.href = '/consultant/dashboard';
                } else {
                    window.location.href = '/dashboard';
                }
            } else {
                toast.error('Invalid login response');
                console.error('Invalid response structure:', response);
            }
        } catch (error) {
            console.error('Login error:', error);
            toast.error('Login failed. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[url('/public/background.jpg')] bg-cover bg-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow-2xl">
                <div>
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                        Sign in to your account
                    </h2>
                </div>
                <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                    <div className="rounded-md shadow-sm space-y-4">
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                                Email
                            </label>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="appearance-none rounded-lg relative block w-full px-4 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                                placeholder="Enter your email"
                            />
                        </div>
                        <div className="mt-4">
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                                Password
                            </label>
                            <input
                                id="password"
                                name="password"
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="appearance-none rounded-lg relative block w-full px-4 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                                placeholder="Enter your password"
                            />
                        </div>
                    </div>

                    <div>
                        <button
                            type="submit"
                            disabled={isLoading}
                            className={`
                                w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 
                                text-white rounded-lg shadow-md relative
                                ${isLoading ? 'opacity-70 cursor-not-allowed' : ''}
                            `}
                        >
                            {isLoading ? (
                                <>
                                    <span className="opacity-0">Login</span>
                                    <div className="absolute inset-0 flex items-center justify-center">
                                        <Loader size="small" color="white" variant="dots" />
                                    </div>
                                </>
                            ) : (
                                'Login'
                            )}
                        </button>
                    </div>
                    <div className="text-sm text-center">
                        <a 
                            href="/forgot-password" 
                            className="font-medium text-blue-600 hover:text-blue-500"
                        >
                            Forgot your password?
                        </a>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Login; 